import React from 'react';
import { Paragraph, Headline, Span, Image } from 'Common';
import { balloonie, clouds } from 'images/PromotionalBanner/NewYears';
import { PromotionalBanner } from 'components/Component';
import { colors } from 'components/Theme';

export const NewYearsBanner = () => {
  const COUPON_CODE = 'NEWYEAR2026';
  const backgroundColor = colors.blue.c800;

  return (
    <PromotionalBanner
      couponCode={COUPON_CODE}
      backgroundColor={backgroundColor}
      leftImage={<Image src={balloonie} className="left-image ny-balloonie" alt="Eine Figur fliegt auf einer Rakete" />}
      rightImage={<Image src={clouds} className="right-image ny-clouds" alt="Wolken" />}
      mobileImage={<Image src={balloonie} className="mobile-image ny-mobile-image" alt="Eine Figur fliegt auf einer Rakete" />}
    >
      <Headline level={2}>Achtsam ins neue Jahr starten</Headline>
      <Paragraph>
        Jetzt <Span className="bold">50% </Span> Neujahrs-Rabatt sichern
      </Paragraph>
    </PromotionalBanner>
  );
};
